import React, { Component } from 'react';
import PropTypes from 'prop-types';
import decl from '../../../helpers/decl';

import DragRange from './drag-range';

class BonusDrag extends Component {
  static propTypes = {
    amount: PropTypes.number,
    maxBonusPay: PropTypes.number,
    balance: PropTypes.number,
    count: PropTypes.number,
    checked: PropTypes.number,
    changeBonusCount: PropTypes.func,
    disable: PropTypes.bool,
  };

  state = {
    key: 0,
  };

  componentWillReceiveProps(nextProps) {
    if (!nextProps.disable) {
      this.setState({
        key: this.state.key + 1,
      });
    }
  }

  render() {
    const { key } = this.state;
    const {
      amount,
      maxBonusPay,
      balance,
      count,
      checked,
      changeBonusCount,
      disable,
    } = this.props;

    let price = amount / count;
    let av = Math.floor(balance / price);
    let items = count;

    if (av < items || av == 0) {
      items = av;
    }

    // if (balance == 0 || av == 0) return null;

    let remainBalance = balance - checked * price;

    return (
      <div
        className="drag-block"
        style={{ pointerEvents: !balance || balance == 0 ? 'none' : 'auto' }}
      >
        <h5 className="drag-block__title">
          На вашей карте {balance}{' '}
          {decl(balance, ['бонус', 'бонуса', 'бонусов'])}
        </h5>
        <div className="drag-block__inner">
          <DragRange
            key={key}
            count={balance > maxBonusPay ? maxBonusPay : balance}
            value={count}
            onChange={changeBonusCount}
            disable={disable}
            price={1}
            reflow={this.props.reflow}
          />
          <p className="drag-block__total">
            {count > 0
              ? `Списать ${count} ${decl(count, [
                  'бонус',
                  'бонуса',
                  'бонусов',
                ])}`
              : 'Не списывать бонусы'}
          </p>
        </div>
      </div>
    );

    // Old realization
    return (
      <div
        className="drag-block"
        style={{
          pointerEvents:
            !balance || balance == 0 || balance < price ? 'none' : 'auto',
        }}
      >
        <h5 className="drag-block__title">Оплатить бонусами</h5>
        <div className="drag-block__inner">
          <DragRange
            key={key}
            count={items}
            value={checked}
            onChange={changeBonusCount}
            disable={disable}
            price={price}
            reflow={this.props.reflow}
          />
        </div>
        <p className="drag-block__total">
          {balance} {decl(balance, ['бонус', 'бонуса', 'бонусов'])}
          <span>на вашей карте</span>
        </p>
      </div>
    );
  }
}

export default BonusDrag;
